import { PrimaryBigButton } from 'components/ReusableComponents/Button/BigButtons'

import styles from './BottomBar.module.scss'

const ChatBotBottomBar = ({ onSubmit }) => (
  <div className={styles.bottomBar}>
    <div className={styles.container}>
      <PrimaryBigButton onClick={onSubmit}>Save changes</PrimaryBigButton>
    </div>
  </div>
)

export default ChatBotBottomBar
